import { useNavigate } from "react-router-dom"

type HeadTableRowType = {
    info: string
    content: string | any
    link?: string
    contentEnd?: boolean
}

export default function HeadTableRow(props: HeadTableRowType) {
    const navigate = useNavigate()

    return (
        <div
            onClick={props.link !== undefined ? () => navigate(props.link as string) : undefined}
            className={`flex flex-row gap-2 text-sm justify-start w-full ${props.contentEnd ? "items-end" : "items-start "}`}>
            <p className="font-medium w-48">{props.info}:</p>
            <p className={`${props.link && "cursor-pointer hover:underline"} w-full truncate`}>{props.content}</p>
        </div>
    )
}